import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { MatchingSessionState, SessionStore } from '@data/session/session.store';
import { ObservableUtil } from '@shared/util/observable.util';
import { MatchingSession } from '@data/session/session.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionQuery extends QueryEntity<MatchingSessionState> {
  protected override store: SessionStore;

  readonly selectWhenTruthyActiveSession$: Observable<MatchingSession> =
    ObservableUtil.takeWhenTruthy(this.selectActive());

  readonly selectOnlyTruthyActiveSession$: Observable<MatchingSession> =
    ObservableUtil.takeOnlyTruthy(this.selectActive());

  constructor() {
    const store = inject(SessionStore);

    super(store);

    this.store = store;
  }
}
